import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css'; 
import ResearchSidebar from '../../Components/ResearchSidebar';
import { API_BASE_URL } from '../../utils/apiConfig.js';
const Account = ({ currentUser, setCurrentUser }) => {
  // state
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    organization: '',
    email: ''
  });
  
  const [passwords, setPasswords] = useState({
    newPassword: '',
    confirmPassword: ''
  });

  const [message, setMessage] = useState({ text: '', type: '' });
  const [isEditing, setIsEditing] = useState(false);

  // Fetch User Data on Load 
  useEffect(() => {
    if (currentUser) {
      axios.get(`${API_BASE_URL}/api/account?email=${currentUser}`)
        .then(res => {
          setFormData(res.data);
        })
        .catch(err => console.error("Error fetching account:", err));
    }
  }, [currentUser]);

  // Handle Account Info Update ---
  const handleInfoSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: '', type: '' });

    try {
      const res = await axios.put(`${API_BASE_URL}/api/account/update-info`, {
        ...formData,
        newEmail: formData.email,
        currentEmail: currentUser 
      });
      
      setMessage({ text: res.data.message, type: 'success' });
      setIsEditing(false); // Switch back to view mode
      
      // Update global app state if email changed
      if (formData.email !== currentUser) {
        setCurrentUser(formData.email);
      }
    } catch (err) {
      console.error(err);
      setMessage({ text: "Failed to update information.", type: 'error' });
    }
  };

  // Handle Password Change 
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: '', type: '' });

    if (passwords.newPassword !== passwords.confirmPassword) {
      setMessage({ text: "Passwords do not match.", type: 'error' });
      return;
    }

    try {
      const res = await axios.put(`${API_BASE_URL}/api/account/change-password`, {
        email: currentUser,
        newPassword: passwords.newPassword
      });
      
      setMessage({ text: res.data.message, type: 'success' });
      setPasswords({ newPassword: '', confirmPassword: '' });
    } catch (err) {
      console.error(err);
      setMessage({ text: "Failed to update password.", type: 'error' });
    }
  };
  
  return (
    <main className="dashboard-layout">
      <ResearchSidebar />

      <div className="dashboard-content">
        <h1 className="page-title">Account Settings</h1>

        {/* Global Status Message */}
        {message.text && (
          <div style={{ 
            padding: '15px', 
            marginBottom: '20px', 
            borderRadius: '8px',
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24',
            border: message.type === 'success' ? '1px solid #c3e6cb' : '1px solid #f5c6cb'
          }}>
            {message.text}
          </div>
        )}

        <div className="grid-2-col">
          
          {/* left card, personal info */}
          <div className="modern-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                <h2 style={{ fontSize: '1.25rem', margin: 0, color: '#333' }}>Personal Information</h2>
                {!isEditing && (
                    <button 
                        onClick={() => setIsEditing(true)} 
                        style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', fontWeight: '600' }}
                    >
                        Edit
                    </button>
                )}
            </div>

            {isEditing ? (
                /* edit mode form */
                <form onSubmit={handleInfoSubmit}>
                  <div className="grid-2-col" style={{ gap: '1rem', marginBottom: '0' }}>
                    <div className="form-group">
                      <label className="form-label">First Name</label>
                      <input 
                        className="modern-input"
                        value={formData.firstName || ''} 
                        onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Last Name</label>
                      <input 
                        className="modern-input"
                        value={formData.lastName || ''} 
                        onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                      />
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">Organization</label>
                    <input 
                      className="modern-input"
                      value={formData.organization || ''} 
                      onChange={(e) => setFormData({...formData, organization: e.target.value})}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Email Address</label>
                    <input 
                      className="modern-input"
                      type="email" 
                      value={formData.email || ''} 
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                    />
                  </div>
                  
                  <div style={{ display: 'flex', gap: '10px', marginTop: '1rem' }}>
                      <button type="submit" className="btn-primary" style={{ flex: 1 }}>Save Changes</button>
                      <button 
                        type="button" 
                        onClick={() => setIsEditing(false)} 
                        className="btn-primary" 
                        style={{ flex: 1, backgroundColor: '#6c757d' }}
                      >
                        Cancel
                      </button>
                  </div>
                </form>
            ) : (
                /* view mode display */
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div>
                        <div className="form-label" style={{ color: '#888' }}>Full Name</div>
                        <div style={{ fontSize: '1.1rem', fontWeight: 500 }}>{formData.firstName} {formData.lastName}</div>
                    </div>
                    <div>
                        <div className="form-label" style={{ color: '#888' }}>Organization</div>
                        <div style={{ fontSize: '1.1rem', fontWeight: 500 }}>{formData.organization || 'Not provided'}</div>
                    </div>
                    <div>
                        <div className="form-label" style={{ color: '#888' }}>Email Address</div>
                        <div style={{ fontSize: '1.1rem', fontWeight: 500 }}>{formData.email}</div>
                    </div>
                </div>
            )}
          </div>

          {/* Right card, change password */}
          <div className="modern-card">
            <h2 style={{ fontSize: '1.25rem', marginBottom: '1.5rem', borderBottom: '1px solid #eee', paddingBottom: '10px', color: '#333' }}>
                Change Password
            </h2>
            
            <form onSubmit={handlePasswordSubmit}>
              <div className="form-group">
                <label className="form-label">New Password</label>
                <input 
                  className="modern-input"
                  type="password" 
                  placeholder="Enter new password"
                  value={passwords.newPassword}
                  onChange={(e) => setPasswords({...passwords, newPassword: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <input 
                  className="modern-input"
                  type="password" 
                  placeholder="Confirm new password"
                  value={passwords.confirmPassword}
                  onChange={(e) => setPasswords({...passwords, confirmPassword: e.target.value})}
                  required
                />
              </div>
              
              <button type="submit" className="btn-primary" style={{ width: '100%', marginTop: '1rem', backgroundColor: '#333' }}>
                Update Password
              </button>
            </form>
          </div>

        </div>
      </div>
    </main>
  );
};

export default Account;